import React from "react";
import { Modal, ModalFooter, ModalHeader, ModalBody } from "reactstrap";


const InfoModal = ({isModalOpen, setModalOpen}) => {

  const closeModal = ()=> setModalOpen(false);

  return(
    <Modal isOpen={isModalOpen} toggle={closeModal} centered>

      <ModalHeader toggle={closeModal}> Tokens </ModalHeader>

      <ModalBody>
        <p>You can get new tokens by playing on the daily wheel of fortune or by completing surveys and offers you will get a lot of tokens.</p>
      </ModalBody>

      <ModalFooter className="jc-center">
        <button className="btn btn-danger pull-left" onClick={()=> setModalOpen(false)}> Cancel </button>
      </ModalFooter>

    </Modal>
  );

}

export default InfoModal;
